import {IReg} from "/@lib@/commons/registry.js";
import {ICoreUniverseEnv} from "/@lib@/core/universe.js";
import {IEndPoint} from "/@lib@/commons/io/io.js";
import {IEsRequestBuilder, JEsResponse} from "/@lib@/store/es.js";
import {IInfo, IInfoProducer} from "/@lib@/commons/infos.js";

/**
 * Interface généraique d'exsutions d'une requête de recherche pour abstraire
 * la technique de construction de la requete et du résultat : appel ES direct ou
 * indirect via sécuriatsion java, combinaison avec un autre moteur de rechereche (urlTree...)
 */
export interface ISearchEngine<P, R> {
	search(props: P): Promise<R>
}

/**
 * Engine de recherche pour ES avec construction de la requête via un IEsRequestBuilder local (côté js).
 */
export class EsSearchEngine<P, R extends JEsResponse> implements ISearchEngine<P, R> {

	reg: IReg<ICoreUniverseEnv>;

	esSearchEndPoint: IEndPoint;

	esReqBd: IEsRequestBuilder;

	constructor(reg: IReg<ICoreUniverseEnv>, esSearchEndPoint: IEndPoint, esReqBd: IEsRequestBuilder) {
		this.reg = reg;
		this.esSearchEndPoint = esSearchEndPoint;
		this.esReqBd = esReqBd;
	}

	search(props: P): Promise<R> {
		const req = this.esReqBd.buildRequest(props);
		return this.esSearchEndPoint.fetchJson<R>(null, {method: "POST", body: JSON.stringify(req), headers: {"Content-Type": "application/json"}})
	}
}

/**
 * Demande une reconstruction des critères de recherche à partir de ces props.
 */
export class InfoResetSearchCrits<P> implements IInfo {
	/**  */
	props: P;

	constructor(props: P) {
		this.props = props;
	}

	infoHolders?: IInfoProducer[];
}

/**
 * Changement des props issus des critères de recherche.
 */
export class InfoSearchCritsChange<P> implements IInfo {
	/** Nouvelle version des Props */
	props: P;

	/** Props précédents. */
	prevProps?: P;

	constructor(props: P, prevProps?: P) {
		this.props = props;
		this.prevProps = prevProps;
	}

	infoHolders?: IInfoProducer[];
}


/**
 * Informe d'un nouveau résultat de recherche à partir de ces props.
 */
export class InfoSearchResults<P, R> implements IInfo {
	/**  */
	props: P;
	results: R;

	constructor(props: P, results: R) {
		this.props = props;
		this.results = results;
	}

	infoHolders?: IInfoProducer[];
}
